import Crud from '../components/RequestAccess/Crud'
import RequestAccess from '../components/RequestAccess/RequestAccess'

let routes = {
    path: '/equestAccess',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
      {
          path: '/requestAccess',
          name: 'Requisição de Acesso',
          component: Crud
      },
      {
        path: '/requestAccess/:id',
        name: 'Moderar Requisição de Acesso',
        component: RequestAccess
    },
    ]
}

export default routes


// WEBPACK FOOTER //
// ./src/router/requestAccess.js